import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../core/auth/useAuth";
import { configureAmplify } from "../core/config/amplify";
import UnauthenticatedApp from "../features/auth/components/UnauthenticatedApp";
import AuthenticatedLayout from "../shared/components/layout/AuthenticatedLayout";

configureAmplify();

function App() {
  const {
    loginState,
    isActionLoading,
    isLoading,
    handleSignOut,
    currentAuthenticatedUser,
  } = useAuth();

  useEffect(() => {
    currentAuthenticatedUser();
  }, [currentAuthenticatedUser]);

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <CircularProgress />
      </div>
    );
  }

  // Authenticated — all routes go to AuthenticatedLayout;
  if (loginState.state === "logged_in") {
    return (
      <Routes>
        <Route
          path="/*"
          element={
            <AuthenticatedLayout
              handleSignOut={handleSignOut}
              isActionLoading={isActionLoading}
            />
          }
        />
      </Routes>
    );
  }

  return <UnauthenticatedApp />;
}

export default App;
